import * as React from "react";
import {
  Hamburger,
  NavDrawer,
  NavDrawerBody,
  NavDrawerHeader,
  NavItem,
  NavSectionHeader,
  Tooltip,
  makeStyles,
  tokens,
  useRestoreFocusTarget,
} from "@fluentui/react-components";

import {
  ArrowSwapRegular,
  BugRegular,
  DatabaseRegular,
  SettingsRegular,
  TableRegular,
  TicketHorizontalRegular,
} from "@fluentui/react-icons";

import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  root: {
    background: tokens.colorNeutralBackground2,
    overflow: "hidden",
    display: "flex",
  },
  nav: {
    minWidth: "200px",
  },
  navcompact: {
    width: "62px",
  },
  navicon: {
    fontSize: "20px",
  },
  NavItem: {
    background: tokens.colorNeutralBackground2,
  },
  content: {
    flex: "1",
    padding: "16px",
    display: "grid",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  field: {
    display: "flex",
    marginTop: "4px",
    marginLeft: "8px",
    flexDirection: "column",
    gridRowGap: tokens.spacingVerticalS,
  },
});

//const Person = bundleIcon(Person20Filled, Person20Regular);

//type DrawerType = Required<DrawerProps>["type"];

function NavigationPanel({ isMinimized, setIsMinimized }) {
  const { t } = useTranslation();
  const styles = useStyles();

  const [isMultiple, setIsMultiple] = React.useState(true);

  // Tabster prop used to restore focus to the navigation trigger for overlay nav drawers
  const restoreFocusTargetAttributes = useRestoreFocusTarget();

  const location = useLocation();

  return (
    <div className={styles.root}>
      <NavDrawer
        defaultSelectedValue={location.pathname}
        defaultSelectedCategoryValue=""
        open="true"
        type="inline"
        multiple={isMultiple}
        className={isMinimized ? styles.navcompact : styles.nav}
        style={{
          height: "100%",
          overflow: "auto",
          padding: "0",
        }}
      >
        <NavDrawerHeader>
          <div style={{ display: "flex" }}>
            <Tooltip content="Close Navigation" relationship="label">
              <Hamburger onClick={() => setIsMinimized(!isMinimized)} />
            </Tooltip>
          </div>
        </NavDrawerHeader>

        <NavDrawerBody>
          <NavItem href="/tickets" value="/tickets">
            <TicketHorizontalRegular className={styles.navicon} />
            {!isMinimized && <span>{t("generic.tickets")}</span>}
          </NavItem>
          <NavItem href="/problems" value="/problems">
            <BugRegular className={styles.navicon} />
            {!isMinimized && <span>{t("generic.problems")}</span>}
          </NavItem>
          <NavItem href="/changes" value="/changes">
            <ArrowSwapRegular className={styles.navicon} />
            {!isMinimized && <span>{t("generic.changes")}</span>}
          </NavItem>
          <NavItem href="/ci" value="/ci">
            <DatabaseRegular className={styles.navicon} />
            {!isMinimized && <span>CMDB</span>}
          </NavItem>

          {!isMinimized ? <NavSectionHeader>Administration</NavSectionHeader> : <hr />}
          <NavItem href="/data" value="/data">
            <TableRegular className={styles.navicon} />
            {!isMinimized && <span>{t("generic.data")}</span>}
          </NavItem>
          <NavItem href="/settings" value="/settings">
            <SettingsRegular className={styles.navicon} />
            {!isMinimized && <span>{t("generic.settings")}</span>}
          </NavItem>
        </NavDrawerBody>
      </NavDrawer>
    </div>
  );
}

export default NavigationPanel;
